import { RotateRight } from '@mui/icons-material';
import { formatTranslation } from 'intl';
import React from 'react';
import { useIntl } from 'react-intl';
import { useGalleryContext } from '..';
import { identitySelector } from '../selectors';
import { ActionsType } from '../types';
import { useDialog } from 'components/core/Dialog/common/DialogContext';
import { fileKindService } from 'services/fileService';
import {
  getFileTypeNotSupportedForGraphicOperationTitle,
  getNoPermissionTitle,
  getPendingConversionPdfTitle,
} from './model';
import { ActionButton } from './actionButton';
import { rotateFileDialog } from 'components/core/Dialog/common/dialogTemplates';
import { getNextQuarterTurnRotation } from 'helpers/image';
import { FileTranslationKeys } from 'intl/keys';

interface RotateButtonProps {
  idx: number;
  actions: ActionsType;
  isMobile: boolean;
}

export const RotateButton: React.FC<RotateButtonProps> = ({
  idx,
  actions,
  isMobile,
}) => {
  const intl = useIntl();
  const [file] =
    useGalleryContext().useMainDisplayedFile(identitySelector);
  const { preview } = useGalleryContext();
  const createDialog = useDialog();

  const ROTATE_LABEL = formatTranslation(intl, FileTranslationKeys.fileRotationLabel,);

  let rotationDisabled = false;
  let rotationTooltipTitle = ROTATE_LABEL;

  if (preview || !file) {
    rotationDisabled = true;
    rotationTooltipTitle = getNoPermissionTitle(intl);
  } else if (fileKindService.isPendingConversionPdf(file)) {
    rotationDisabled = true;
    rotationTooltipTitle = getPendingConversionPdfTitle(intl);
  } else if (!fileKindService.isFileImage(file)) {
    rotationDisabled = true;
    rotationTooltipTitle =
      getFileTypeNotSupportedForGraphicOperationTitle(intl);
  }

  const handleRotateRight = (): void => {
    const newRotation = getNextQuarterTurnRotation(file?.imageRotation);
    createDialog(rotateFileDialog()).then(() => {
      actions.rotateFile(idx, newRotation);
    });
  };

  return (
    <ActionButton
      isMobile={isMobile}
      onClick={handleRotateRight}
      disabled={rotationDisabled}
      tooltipTitle={rotationTooltipTitle}
      label={ROTATE_LABEL}
      icon={<RotateRight />}
      additionalIconButtonSx={{
        transform: `rotate(${file?.imageRotation ?? 0}deg)`,
        transition: 'transform 0.3s ease-in-out',
      }}
    />
  );
};
